import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Layout from '../../components/templates/layout';
import Card from '../../components/molecules/card';
import { useIntl } from '../../common/config/i18n';

const StyledError404 = styled.div`
  margin-top: 20px;
`;
const Error404: React.FC = () => {
  const { t } = useIntl();

  return (
    <div>
      <Layout />
      <StyledError404>
        <Card title={t('Error404', 'ERROR404_TITLE')}>
          <p style={{ textAlign: 'center' }}>{t('Error404', 'ERROR404_MESSAGE')}</p>
          <Link to="/">{t('Error404', 'ERROR404_BACK')}</Link>
        </Card>
      </StyledError404>
    </div>
  );
};
export default Error404;
